<template>
  <div class="viewership-time-frame">
    <div class="viewership-time-frame__label">Type</div>
    <div class="viewership-time-frame__value" @click="clickHandler">
      {{ selectedText }} <svg-icon :icon="arrow" :width="12" :height="8"></svg-icon>
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import arrow from '@/assets/svg/arrow.svg'
import { createPopover, popoverTypes } from '@/components/common/popover'
import { ACTIVATION_STATUS } from '@/appLogic/targets/Constants'

const viewershipOptions = [
  {
    name: 'Live',
    value: 'aalive'
  },
  {
    name: 'LSD',
    value: 'aalivesd'
  },
  {
    name: 'C3',
    value: 'aalive3'
  },
  {
    name: 'C7',
    value: 'aalive7'
  }
]

export default {
  components: {
    SvgIcon
  },
  props: {
    selectedViewshipOption: String,
    validStreamingOptions: Array
  },
  data () {
    return {
      arrow,
      popover: null
    }
  },
  computed: {
    selectedText () {
      return viewershipOptions.find(option => option.value === this.selectedViewshipOption).name
    }
  },
  methods: {
    clickHandler (e) {
      if (this.$store.state.currentTarget.currentTarget.activation_status === ACTIVATION_STATUS.LIVE) return
      this.popover = createPopover({
        direction: 'bottom',
        list: viewershipOptions.filter(v => this.validStreamingOptions.includes(v.name)),
        parent: e.currentTarget,
        root: document.getElementById('app'),
        type: popoverTypes.TEXTLIST
      })
      this.popover
        .$on('select', selected => {
          this.$emit('selected', selected)
        })
    }
  }
}
</script>

<style lang="scss">
.viewership-time-frame {
  display: flex;
  flex-direction: column;

  &__label {
    text-transform: uppercase;
    font-weight: bold;
    font-size: rem(12);
    padding: 0 rem(8) 0 rem(8);
  }

  &__value {
    flex-shrink: 0;
    font-size: rem(12);
    border-bottom: rem(1) solid color(grays, light);
    cursor: pointer;
    padding: rem(2) rem(6) 0 rem(8);
  }

  svg {
    fill: color(blues, normal);
    transform: rotate(90deg);
    width: rem(12) !important;
    height: rem(12) !important;
  }
}
</style>



// WEBPACK FOOTER //
// ViewershipTimeFrame.vue?7bed3a8c